import React, {useEffect, useRef} from "react";
import {IItemContent} from "@connox/typescript-library";
import ItemCard from "../../ProductSeries/ItemCard";
import {AddToCartButton} from "../../cart/AddToCartButton/AddToCartButtonPortal";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "swiper-container": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        init: boolean;
      };
      "swiper-slide": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

type SwiperConstructType = {
  items: IItemContent[];
  title: string;
  breakpoints?: BreakpointType;
  link?: React.ReactNode;
  isCartSwiper?: boolean;
};
export type BreakpointType = {[key in 481 | 651 | 768 | 851 | 941 | 1132]?: {slidesPerView: number}};

type TemporarySwiperParamsType = {
  initialize?: () => void;
  mousewheel: {forceToAxis: true};
  navigation: {
    nextEl: HTMLSpanElement;
    prevEl: HTMLSpanElement;
  };
  slidesPerView: number;
  breakpoints: BreakpointType;
  slidesOffsetBefore: number;
  slidesOffsetAfter: number;
  spaceBetween: number;
};

export const defaultBreakpoints: BreakpointType = {
  481: {
    slidesPerView: 3.2,
  },
  768: {
    slidesPerView: 4.5,
  },
};

const SwiperConstruct: React.FC<SwiperConstructType> = ({
  items,
  title,
  link,
  breakpoints = defaultBreakpoints,
  isCartSwiper,
}) => {
  const swiperRef = useRef<HTMLElement & TemporarySwiperParamsType>(null);
  const prevSpanRef = useRef(null);
  const nextSpanRef = useRef(null);

  useEffect(() => {
    if (
      items.length &&
      swiperRef.current &&
      swiperRef.current.initialize &&
      prevSpanRef.current &&
      nextSpanRef.current
    ) {
      swiperRef.current.parentElement?.classList.add("visible");
      swiperRef.current.classList.add("swiper-cross-selling__container");
      swiperRef.current.slidesPerView = 1.5;
      swiperRef.current.spaceBetween = 8;
      swiperRef.current.mousewheel = {forceToAxis: true};
      swiperRef.current.breakpoints = breakpoints;

      swiperRef.current.navigation = {
        nextEl: nextSpanRef.current,
        prevEl: prevSpanRef.current,
      };
      swiperRef.current.initialize();
    }
  }, [items]);

  if (!items.length) {
    return null;
  }

  return (
    <div className="swiper-cross-selling pb-7">
      <h2 className="fill">{title}</h2>
      {link && <p>{link}</p>}
      <swiper-container init={false} ref={swiperRef}>
        {items.map((item, key) => {
          return (
            <swiper-slide key={key}>
              <ItemCard item={item} />
              {isCartSwiper ? <AddToCartButton itemId={item.itemId} isSwiperAddToCartButton={true} /> : null}
            </swiper-slide>
          );
        })}
      </swiper-container>
      <div className="swiper-btn-prev" ref={prevSpanRef}>
        <span className="icon icon-chevron-left icon-size--32">&nbsp;</span>
      </div>
      <div className="swiper-btn-next" ref={nextSpanRef}>
        <span className="icon icon-chevron-right icon-size--32">&nbsp;</span>
      </div>
    </div>
  );
};

export default SwiperConstruct;
